import { changeAuthContext } from "./accountActions";
import { fetchBusinessDetails } from "./businessActions";

export const CHANGE_BUSINESS = "@settings/change-business";


export function changeBusiness(email, businessInfo) {
  return async (dispatch) => {   
    
    // console.log("changeBusiness() : ", businessInfo);
    try {

      await dispatch(changeAuthContext(email, businessInfo?.customerId));;

      dispatch({ type: CHANGE_BUSINESS, payload :{ businessInfo: businessInfo  }});

      dispatch(fetchBusinessDetails(businessInfo?.customerId));
      // console.log("changeBusiness() Fetching Customer Detail", businessInfo?.customerId );
    } catch (error) {

    }
  };
}
